export default "__VITE_ASSET__CIZk_yCd__"